import React, { Fragment } from 'react'
import { Box, Flex, Heading, Stack } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { formatDate } from '../../utils/helper-functions'

export const AllAlbums = ( props ) => {
  let studioAlbums = []
  let singlesEPs = []
  const { artist, hotAlbums, nextAlbumsArr, pageCount, resultsPerPage, totalResults } = props
  // console.log( "all albums", hotAlbums )
  const filterAlbums = ( subType, type ) => {
    // 专辑 = album
    // Demo及其他 = Demo and others
    // 录音室版 = Studio Version
    const filtered = hotAlbums.filter( al => {
      // console.log( "al--SUBTYPE:", al.subType )
      console.count( "filtered albums render count" )
      // console.log( "al--TYPE:", al.type )
      if ( al.type === "专辑" && al.subType === "录音室版" ) {
        studioAlbums.push( al )
      } else if ( al.type === "Single" || al.subType === "EP/Single" ) {
        singlesEPs.push( al )
      }
    } )
    // console.log( filtered )
    return filtered
  }
  // console.log( filterAlbums(), "filterAlbums" )
  return (
    <Flex
      display="flex"
      width="100%"
      flexDir="column"
      alignItems="center"
      px={[1, 2, 3, 3]}>
      <Box display="block">
        <Heading fontWeight="light">
          {artist?.name}'s Albums:
          {hotAlbums?.length}
        </Heading>
        <Heading
          fontSize="xs"
          fontWeight="light">
        </Heading>
      </Box>
      <Stack
        isInline
        justifyContent="space-between"
        flexWrap="wrap"
        my={1}>
        <Heading fontSize="sm">
          STUDIO ALBUMS
        </Heading>
        <Heading fontSize="sm">
          EPs & SINGLES
        </Heading>
      </Stack>
      <Stack isInline>
        {studioAlbums?.length && studioAlbums?.map( al => {
          return (
            <Link key={al.id} to={`/album/${al.id}`}>
              <img key={al?.id} src={al?.picUrl + "?param=300y300"} alt={al?.name}
                style={{ width: "100px" }}
              />
            </Link>
          )
        } )}
        {singlesEPs?.length && singlesEPs?.map( al => {
          return (
            <Link key={al.id} to={`/album/${al.id}`}>
              <img key={al?.id} src={al?.picUrl + "?param=300y300"} alt={al?.name}
                style={{ width: "100px" }}
              />
            </Link>
          )
        } )}
      </Stack>
    </Flex>
  )
}
/**  {hotAlbums?.map( ( al, i ) => {
                    // console.log( "type: ", al?.type, "subType:", al?.subType )
                    if ( al?.subType === "录音室版" && al?.type === "专辑" ) {
                        al.type = "Album"
                        al.subType = "Studio Version"
                        studioAlbums.push( al )
                    } else {
                        al.type === ( "Single" || "EP/Single" || "EP" || "专辑" ) && al.subType === "录音室版" || al.subType === null || al.subType === "" ? al.subType = "EP/Single" : al.subType
                        singlesEPs.push( al )
                    }
                    // console.log( "singlesEPs", singlesEPs )
                    // console.log( "studioAlbums", studioAlbums )
                    return (
                        <Link key={al.id} to={`/album/${al.id}`}>
                            {i + 1}. {al.name.substring( 0, 18 )}
                            {" ["}{formatDate( al?.publishTime ).slice( 0, 4 )}{"] "}
                            <br />
                            Type:  {al?.type}
                            <br />
                            SubType:  {al?.subType}
                            <img src={al?.picUrl + "?param=250y250"} alt={al?.name}
                                style={{ width: "115px" }} />
                        </Link>
                    )
                } )}
*/
